import { FC } from "react";

const ErrorMessage: FC = (): JSX.Element => {
  return (
    <p className="text-danger text-center p-4">
      エラーが発生しました。
      <br />
      時間をおいて再度お試しください。
    </p>
  );
};
export default ErrorMessage;
